var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.CallMeBack.Messages.Submit, Vendd.CallMeBack, function (envelope) {
        var options = {
            url: 'CallMeBackService.svc/SubmitCallMeBackRequest',
            data:
            {
                info: envelope.message.data.model
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.CallMeBack, new Vendd.CallMeBack.Messages.SubmitSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.CallMeBack, new Vendd.CallMeBack.Messages.SubmitFailure(response));
            }
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.CallMeBack, new Vendd.CallMeBack.Messages.SubmitFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.CallMeBack.CreateCallMeBackInfo = function () {

        var callMeBackInfo = {
            Email: '',
            FirstName: '',
            LastName: '',
            Phone: '',
            Message: '',
            Source: ''
        };


        var observable = new Vendd.Observable(callMeBackInfo);
        return observable;
    };

    Vendd.CallMeBack.CreateDefaultCallMeBackInfoValidationModel = function (observable) {



        var defaultValidationModel = ({
            FirstName: [{ rule: "required" }],
            LastName: [{ rule: "required" }],
            Email: [{ rule: "required" }, { rule: "isEmail" }],
            Phone: [{ rule: "required" }, { rule: "isNumeric" }]
        });

        var valEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

        var propertyChanging = function propertyChanging(data, propertyName, value) {

            var valOptions = {
                ValidationEngine: valEngine,
                PropertyName: propertyName,
                PropertyValue: value
            };
            Vendd.DataValidation.Validate(valOptions);
        };

        observable.AddListenerToPropertyChanging('FirstName', propertyChanging);
        observable.AddListenerToPropertyChanging('LastName', propertyChanging);
        observable.AddListenerToPropertyChanging('Email', propertyChanging);
        observable.AddListenerToPropertyChanging('Phone', propertyChanging);
        observable.AddListenerToPropertyChanging('Message', propertyChanging);
        return valEngine;
    };

    return Vendd;

})(Vendd || {});